import {
  faLock,
  faBoltAuto,
  faPencil,
} from '@fortawesome/pro-regular-svg-icons'
import { Icon, Tooltip } from '@/ui'

interface IDisplayRowIconProps {
  isLocked: boolean
  isAutoCategorized: boolean
  isManualTransaction: boolean
}

export const DisplayRowIcon = ({
  isLocked,
  isAutoCategorized,
  isManualTransaction,
}: IDisplayRowIconProps) => {
  if (isLocked) {
    return <Icon icon={faLock} className="text-neutral-400" size="lg" />
  }

  if (isAutoCategorized) {
    return (
      <Tooltip>
        <Tooltip.Trigger asChild>
          <Icon
            icon={faBoltAuto}
            className="pointer-events-auto text-neutral-400"
          />
        </Tooltip.Trigger>

        <Tooltip.Content side="top">
          This transaction has been auto-categorized.
        </Tooltip.Content>
      </Tooltip>
    )
  }

  if (isManualTransaction) {
    return <Icon color="bg-green-400" icon={faPencil} />
  }

  return null
}
